import { useState } from "react";

function MenuItemImage({ item }) {
  const [imageFailed, setImageFailed] = useState(false);
  const hasUsableImage = item.image && !imageFailed;
  const categoryName = item.category?.name || "Zayas Kitchen";

  if (hasUsableImage) {
    return (
      <img
        alt={item.name}
        className="food-card-image"
        loading="lazy"
        onError={() => setImageFailed(true)}
        src={item.image}
      />
    );
  }

  return (
    <div className="food-card-image public-menu-placeholder" role="img" aria-label={`${item.name} placeholder`}>
      <span aria-hidden="true">ZK</span>
      <strong>{item.name}</strong>
      <small>{categoryName}</small>
    </div>
  );
}

export default MenuItemImage;